<div class="paragraph-m-medium mb-1 md:mb-2 break-words overflow-y-auto floating-alert__message">{{ alert.message | translate }}</div>
<div class="flex justify-end gap-2 c-primary">
  @for (action of alert.actions; track action) {
    <a acSecondaryLink class="link-m" (click)="action.action()">{{ action.label | translate }}</a>
  }
  <a acSecondaryLink class="link-m" (click)="dismiss()">{{ 'GENERAL.CLOSE' | translate }}</a>
</div>
